<template lang="pug">
.container
  h1.main_title Notification Log
  .loader(v-if="dataLoading")
  .col-md-12(v-else)
    .filter_container
      div
        label.filter_label Type: 
        v-select(
          v-bind:value.sync='filterTypeValue'
          v-bind:options='filterTypeOpts'
          placeholder="None"
        )
      div
        label.filter_label Vendor: 
        v-select(
          v-bind:value.sync='filterFromValue'
          v-bind:options='filterFromOpts'
          placeholder="None"
        )
      div
        label.filter_label Start from:
        input.filter_option.filter_date(
          type="date"
          v-model="filterDateStartValue"
          v-bind:max="today"
        )
      div
        label.filter_label End at:
        input.filter_option.filter_date(
          type="date"
          v-model="filterDateEndValue"
          v-bind:min="filterDateStartValue"
          v-bind:max="today"
        )
      div
        button.btn.btn-info(@click="download")
          span.glyphicon.glyphicon-download
          span  Download
        a.hide(v-el:download)
    .output_data_container
      pagination(
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currentPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='outputData'
        v-if="outputData.length > 10")
      .col-md-12
        span.table_overview.pull-right
          h5 Price: 
            em {{ selectedCurrency.symbol_native }} 
            | {{ totalPrice }} / Amount: {{ outputData.length }}
        table.table.table-hover.table-bordered
          tr
            th Time
              .pull-right
                span.glyphicon(
                  :class="sortIconCreator('time', 'attribute')"
                  @click="sortBy('time')"
                )
            th Type
              .pull-right
                span.glyphicon(
                  :class="sortIconCreator('type', 'alphabet')"
                  @click="sortBy('type')"
                )
            th Device
              .pull-right
                span.glyphicon(
                  :class="sortIconCreator('type', 'alphabet')"
                  @click="sortBy('device')"
                )
            th Source MAC
              .pull-right
                span.glyphicon(
                  :class="sortIconCreator('mac', 'alphabet')"
                  @click="sortBy('mac')"
                )
            th Vendor
              .pull-right
                span.glyphicon(
                  :class="sortIconCreator('from', 'alphabet')"
                  @click="sortBy('from')"
                )
            th To
              .pull-right
                span.glyphicon(
                  :class="sortIconCreator('to', 'alphabet')"
                  @click="sortBy('to')"
                )
            th 
              span Price 
              span.small (
                em {{ selectedCurrency.symbol_native }}
                | )
              .pull-right
                span.glyphicon(
                  :class="sortIconCreator('price', 'attribute')"
                  @click="sortBy('price')"
                )
          tr(v-for="log in outputData | limitBy countOfPage pageStart")
            td {{ log.time | timeFormat }}
            td(:class="{'text-capitalize': log.type === 'mail', 'text-uppercase': log.type === 'sms'}") {{ log.type }}
            td.text-capitalize {{ log.device }}
            td.text-uppercase {{ log.mac }}
            td.text-capitalize {{ log.from }}
            td {{ log.to }}
            td {{ log.price }}
</template>

<script>
  import { getService } from '../../index.js'
  import pagination from '../common/Pagination'
  import { select } from 'vue-strap'
  import moment from 'moment'
  import _ from 'lodash'

  export default {
    props: [],
    components: {
      'v-select': select,
      pagination
    },
    data () {
      return {
        /* default */
        outputData: [],
        /* data status */
        fbServiceLoaded: false,
        /* pagination */
        countOfPage: 25,
        countOfPagination: 5,
        currentPage: 1,
        currPaginationSec: 1,
        /* filter options & values */
        filterTypeValue: 'Any',
        filterTypeOpts: [
          {label: 'Any', value: 'Any'},
          {label: 'SMS', value: 'sms'},
          {label: 'Mail', value: 'mail'}
        ],
        filterFromValue: 'Any',
        filterFromOpts: [
          {label: 'Any', value: 'Any'},
          {label: 'Gomax', value: 'gomax'},
          {label: 'Intrising', value: 'intrising'},
          {label: 'Lantech', value: 'lantech'},
          {label: 'EvoIP', value: 'evoip'}
        ],
        today: moment().format('YYYY-M-D'),
        filterDateStartValue: '',
        filterDateEndValue: '',
        lang: 'en',
        /* sort data */
        currentSortOptions: {
          'time': false,
          'type': null,
          'device': null,
          'mac': null,
          'from': null,
          'to': null,
          'price': null
        }
      }
    },
    vuex: {
      getters: {
        user: state => state.user,
        selectedCurrency: state => state.selectedCurrency
      }
    },
    firebase () {
      return {
        fbService: {
          source: getService(),
          readyCallback: () => {
            this.fbServiceLoaded = true
          }
        }
      }
    },
    computed: {
      dataLoading () {
        if (this.user.role === 'admin' && this.fbServiceLoaded) {
          const { rates } = this.selectedCurrency
          const fbs = [...this.fbService]
          /* normalize data column name (以 mail 的格式為標準)*/
          _.forEach(fbs, (service, index) => {
            if (service.type === 'sms') {
              fbs[index] = {
                ...service,
                price: _.round(_.toFinite(parseFloat(service['message-price'] || service['price'])) * rates, 4)
              }
            }
          })

          /* filter data */
          const filterTypeResult = this.filterTypeValue === 'Any'
            ? fbs
            : _.filter(fbs, s => s.type === this.filterTypeValue)
          // console.log(filterTypeResult)

          const filterFromResult = this.filterFromValue === 'Any'
            ? filterTypeResult
            : _.filter(filterTypeResult, s => s.from === this.filterFromValue)

          const filterDateStartRESULT = this.filterDateStartValue === ''
            ? filterFromResult
            : _.filter(filterFromResult, s => s.time >= new Date(this.filterDateStartValue).toISOString())

          const filterDateEndRESULT = this.filterDateEndValue === ''
            ? filterDateStartRESULT
            : _.filter(filterDateStartRESULT, s => s.time <= new Date(this.filterDateEndValue).toISOString())

          /* sort data */
          const sortType = []
          const AorDESC = []
          _.forEach(this.currentSortOptions, (value, key) => {
            if (value !== null) {
              sortType.push(key)
              AorDESC.push(value ? 'asc' : 'desc')
            }
          })
          // console.log(sortType, AorDESC)

          this.outputData = _.orderBy(filterDateEndRESULT, sortType, AorDESC)
          return false
        } else {
          return true
        }
      },
      totalPrice () {
        let su = 0
        _.forEach(this.outputData, (o) => {
          su += (o.price || 0) * 100000
          // console.log(o.price, su)
        })
        // console.log(su / 100000)
        return su / 100000
      },
      pageStart () {
        return (this.currentPage - 1) * this.countOfPage
      },
      filterCollection () {
        const {filterTypeValue, filterFromValue, filterDateStartValue, filterDateEndValue} = this
        return {
          filterTypeValue, filterFromValue, filterDateStartValue, filterDateEndValue
        }
      }
    },
    ready () {

    },
    methods: {
      download () {
        const { symbol_native: symbolNative } = this.selectedCurrency
        const downtime = new Date().toLocaleDateString()
        const csvTitles = ['Time', 'Type', 'Source MAC', 'Vendor', 'To', `Price (${symbolNative})`]
        const dataKeys = ['time', 'type', 'mac', 'from', 'to', 'price']
        let csvContent = csvTitles.join() + '\r\n'
        let csvToDown = this.outputData
        for (let column of csvToDown) {
          let columnData = dataKeys.map(k => {
            if (k === 'time') {
              return moment(column[k]).format('YYYY-M-D h:mm:ss a')
            } else {
              return column[k]
            }
          })
          csvContent = csvContent + columnData.join() + '\r\n'
        }
        csvContent += ',,,,,\r\n'
        csvContent += `,,,,Total Amount: ${this.outputData.length},Total Price: ${symbolNative} ${this.totalPrice}`
        let textFileAsBlob = new window.Blob([csvContent], {type: 'text/plain'})
        let atag = this.$els.download
        atag.download = `IntriNotify_Log_Report_${downtime}.csv`
        atag.href = window.URL.createObjectURL(textFileAsBlob)
        try {
          console.log('a click', textFileAsBlob)
          atag.click()
        } catch (e) {  // throws when IE
          window.navigator.msSaveBlob(textFileAsBlob, `IntriNotify_Log_Report_${downtime}.csv`)
        }
      },
      sortBy (type) {
        const { currentSortOptions } = this
        switch (currentSortOptions[type]) {
          case null:
            currentSortOptions[type] = true
            break
          case false:
            currentSortOptions[type] = null
            break
          case true:
            currentSortOptions[type] = false
            break
        }
      },
      sortIconCreator (colName, sorType) {
        const icon = {
          'alphabet': 'glyphicon-sort-by-alphabet',
          'order': 'glyphicon-sort-by-order',
          'attribute': 'glyphicon-sort-by-attributes'
        }
        const { currentSortOptions } = this
        return currentSortOptions[colName] !== null
          ? currentSortOptions[colName]
            ? icon[sorType]
            : `${icon[sorType]}-alt`
          : 'glyphicon-sort sort_default'
      }
    },
    watch: {
      filterCollection: {
        deep: true,
        handler: function (nv) {
          this.currentPage = 1
          this.currPaginationSec = 1
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.filter_container {
  display: flex;
  justify-content: space-between;
  padding: 15px;
}

.filter_date {
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 34px;
}

.filter_label {
  padding-right: 6px;
}

.filter_option {
  margin-right: 12px;
}

.sort_default {
  color: rgba(199, 199, 199, 0.5);
}

.table_overview {
  padding: 4px 6px;
}
</style>


// WEBPACK FOOTER //
// ServiceLog.vue?1ff99a98